export interface ApiGetPatentClmsRequest {
    task_id: string;
    query: string;
}

export interface ApiGetPatentClmsResponse {
    pn?: string;
    title?: string;
    claim?: string;
}

export const GetPatentClms = Symbol('GetPatentClms');

export interface GetPatentClms {
    getPatentClms(data: ApiGetPatentClmsRequest): Promise<ApiGetPatentClmsResponse>;
}

